/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var PersonalizationWidgetView = require("personalization-views/PersonalizationWidgetView");
    var PersonalizationWidgetModel = require("personalization-models/PersonalizationWidgetModel");
    var PersonalizationWidgetController = {};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        PersonalizationWidgetController = Marionette.Controller.extend({
            initialize: function (options) {
                    this.personalizationModel = options.personalizationModel;
                    this._setPersonalizationWidgetRegion();
                    this.listenTo(this.personalizationModel, "change:page", this._onPageChange, this);
                    this.listenTo(this.personalizationModel, "change:isReportingOpen", this._onIsReportingOpenChange, this);
            },

            _setPersonalizationWidgetRegion: function () {

                this.personalizationWidgetModel = new PersonalizationWidgetModel();
                this.personalizationWidgetView = new PersonalizationWidgetView({
                    model: this.personalizationWidgetModel
                });
                this.listenTo(this.personalizationWidgetView, "personalizationWidgetView:toggleState", this._toggleState, this);

                LE.vent.trigger("userBarWidgetsLayoutController:showRegion", {
                    region: "personalization",
                    view: this.personalizationWidgetView
                });
            },
            _isMessagingState: function() {
                return LE.sessionManager.hasAsyncMessagingFeature();
            },
            _toggleState: function (options) {
                options=options||{};
                //personalization can be opened only if  featuresByRoutCount >0 but it can be closed for any featuresByRoutCount
                var isOpen = this.personalizationModel.get("isOpen");
                if (options.featuresByRoutCount > 0 || isOpen) {
                    this.personalizationModel.set("isOpen", !isOpen);
                }
            },
            _onPageChange: function (model, page) {
                this.page = page;
                this._setFeaturesByRoutCount(this.page);
            },
            _onIsReportingOpenChange: function (model, isOpen) {
                if (isOpen) {
                    this._setFeaturesByRoutCount(this.page + "_reportingOpen");
                } else {
                    this._setFeaturesByRoutCount(this.page);
                }
            },
            _setFeaturesByRoutCount: function (page) {
                var count = LEPersonalization.getFeaturesByRoutCount({page: page});
                this.personalizationWidgetModel.set("featuresByRoutCount", count);
            }

        });
    });
    return PersonalizationWidgetController;

});